import { AsYouType, parsePhoneNumber, CountryCode } from 'libphonenumber-js';

/**
 * Formats a phone number as the user types based on the selected country
 * @param value - The phone number input value
 * @param countryCode - ISO country code (e.g., 'US', 'GB')
 * @returns Formatted phone number string
 */
export const formatPhoneNumber = (value: string, countryCode: string): string => {
  if (!value) return '';

  try {
    const formatter = new AsYouType(countryCode as CountryCode);
    return formatter.input(value);
  } catch (error) {
    return value;
  }
};

/**
 * Validates a phone number for a specific country
 * @param phoneNumber - The phone number to validate
 * @param countryCode - ISO country code (e.g., 'US', 'GB')
 * @returns true if valid, false otherwise
 */
export const validatePhoneNumber = (phoneNumber: string, countryCode: string): boolean => {
  if (!phoneNumber || !countryCode) return false;

  try {
    const parsed = parsePhoneNumber(phoneNumber, countryCode as CountryCode);
    return parsed ? parsed.isValid() : false;
  } catch (error) {
    return false;
  }
};
